const { fetchAuthorizedJsonApi, fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

/**
 * @return Promise that returns all subscriptions of the logged in user.
 */
function fetchActiveSubscription(apiUrl, token) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: 'v2/subscriptions',
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching subscription',
  });
}

function createSubscription(apiUrl, token, data) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'POST',
    endpoint: 'v1/subscriptions',
    body: data,
    expectedStatus: 201,
    description: 'Creating subscription',
  });
}

function fetchSubscriptionPlans(apiUrl) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v1/subscriptions/plans',
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching subscription plans',
  });
}

function cancelSubscription(apiUrl, token, id) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `v1/subscriptions/${id}/cancel`,
    query: { lang: getApiLanguage() },
    expectedStatus: 204,
    description: 'Canceling subscription',
  });
}

module.exports = {
  fetchActiveSubscription,
  fetchSubscriptionPlans,
  createSubscription,
  cancelSubscription,
};
